export const OPEN_MODAL_SUCCESS = 'OPEN_MODAL_SUCCESS';
export const CLOSE_MODAL_SUCCESS = 'CLOSE_MODAL_SUCCESS';

export const TFA_NOTIFICATION_SUCCESS = 'TFA_NOTIFICATION_SUCCESS';

export const SAVE_MODAL_OPTIONS = 'SAVE_MODAL_OPTIONS';
